import { render, staticRenderFns } from "./SectionPrizes.vue?vue&type=template&id=72cac664&"
import script from "./SectionPrizes.vue?vue&type=script&lang=js&"
export * from "./SectionPrizes.vue?vue&type=script&lang=js&"
import style0 from "./SectionPrizes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports